import { getListOrderAdmin } from "../../../../services/OrderService";
import { PriceDetail } from "../../../../models/Order";

// Larger page size used only for export so we pull ALL matching orders in far
// fewer requests than the list's PERPAGE.PerPage (20). The previous 200-page
// cap silently truncated large exports (e.g. a 416-page result) — removed.
const EXPORT_PER_PAGE = 200;

export default function useExportListOrder(props: { countPages: number }) {
	const loadListOrder = async (
		status?: string[],
		fromDate?: Date | null | undefined,
		toDate?: Date | null | undefined,
		store?: string | null,
		userId?: number | null,
		fromReplyDate?: Date | null | undefined,
		toReplyDate?: Date | null | undefined,
		country?: string | null,
		filterProvice?: string | null,
		id?: string | null,
		stationActive?: string | null
	) => {
		let mergedData: PriceDetail[] = [];
		try {
			const startOfDayFromDate = fromDate ? new Date(new Date(fromDate).setHours(0, 0, 0, 0)) : undefined;
			const endOfDayToDate = toDate ? new Date(new Date(toDate).setHours(23, 59, 59, 999)) : undefined;
			const startOfDayReplyFromDate = fromReplyDate
				? new Date(new Date(fromReplyDate).setHours(0, 0, 0, 0))
				: undefined;
			const endOfDayToReplyDate = toReplyDate
				? new Date(new Date(toReplyDate).setHours(23, 59, 59, 999))
				: undefined;

			const fetchPage = (page: number) =>
				getListOrderAdmin(
					page,
					EXPORT_PER_PAGE,
					status,
					startOfDayFromDate,
					endOfDayToDate,
					store || "",
					userId || 0,
					startOfDayReplyFromDate,
					endOfDayToReplyDate,
					country || "",
					filterProvice || "",
					id,
					stationActive
				);

			// Fetch the first page to learn the real total page count for this
			// filter (at EXPORT_PER_PAGE), then pull every remaining page so the
			// export is never truncated.
			const firstRes = await fetchPage(1);
			mergedData = [...firstRes.data];
			const totalPages = firstRes.numberPage || props.countPages || 1;
			for (let i = 2; i <= totalPages; i++) {
				const res = await fetchPage(i);
				mergedData = [...mergedData, ...res.data];
			}
			return mergedData;
		} catch {
		} finally {
		}
	};
	return {
		loadListOrder,
	};
}
